
import React from 'react';
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { FileText, Users } from './ValoGuideData';

const ValoGuideServices = () => {
  return (
    <section className="py-16 bg-fabre-lightgray">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <header className="mb-12">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-fabre-gray mb-4">
              Nos Services de Valorisation
            </h2>
            <p className="text-lg text-gray-600">
              Découvrez notre gamme complète de services pour la valorisation de vos déchets
            </p>
          </header>
          
          <div className="grid md:grid-cols-2 gap-6 mb-8">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <FileText className="w-12 h-12 text-fabre-green mx-auto mb-4" />
              <h3 className="text-xl font-heading font-bold text-fabre-gray mb-2">
                Valorisation Métaux
              </h3>
              <p className="text-gray-600 mb-4">
                Ferreux, non ferreux, achat au meilleur prix
              </p>
              <Button asChild variant="outline" size="sm" className="border-fabre-green text-fabre-green hover:bg-fabre-lightgreen hover:text-fabre-gray">
                <Link to="/valorisation/metaux-ferreux">En savoir plus</Link>
              </Button>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <Users className="w-12 h-12 text-fabre-green mx-auto mb-4" />
              <h3 className="text-xl font-heading font-bold text-fabre-gray mb-2">
                Gestion DIB
              </h3>
              <p className="text-gray-600 mb-4">
                Déchets industriels banals pour entreprises
              </p>
              <Button asChild variant="outline" size="sm" className="border-fabre-green text-fabre-green hover:bg-fabre-lightgreen hover:text-fabre-gray">
                <Link to="/valorisation/dib">En savoir plus</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValoGuideServices;
